/**
 * Dashboard tile ids, and nothing else.
 *
 * Its own module with ZERO imports on purpose. The run detail route's
 * `validateSearch` schema is loaded eagerly by `router.tsx`, so whatever that
 * schema imports lands in the INITIAL chunk (P1). Nine live ids plus two
 * stale aliases is what the URL parser needs. Everything the dashboard knows
 * ABOUT a focus stays in `run-dashboard-focus.ts`, in the lazy chunk.
 *
 * `extras` and `recoveries` are bookmarks from an earlier IA. They still parse
 * so a sent link opens This month (`cycle`) instead of falling back to the
 * default tile.
 */
export const FOCUS_IDS = [
  "people",
  "cycle",
  "bank",
  "blockers",
  "movements",
  "matrix",
  "publish",
  "holds",
  "process",
  "extras",
  "recoveries",
] as const;

export type DashboardFocusId = (typeof FOCUS_IDS)[number];
